// Local Functions
const isNode = () =>
  // eslint-disable-next-line no-undef -- can run on client and server, given we check for process we should be good to go
  typeof process !== 'undefined' && process.release && process.release.name === 'node';

// eslint-disable-next-line no-undef -- added by Webpack during build time
const isProductionMode = () => process.env.NODE_ENV === 'production';

const isRetinaDisplay = () => window.devicePixelRatio >= 2;

const isWindows = () => globalThis.navigator.platform === 'Win32';

const isIosDevice = () => /i(?:Pad|Phone)/.test(globalThis.navigator.platform);

// Module Exports
export { isIosDevice, isNode, isProductionMode, isRetinaDisplay, isWindows };
